import { useCookies } from 'react-cookie';
import Layout from '../../components/Layout';
import ActualitesBloc from './ActualitesBloc';
import BureauxBloc from './BureauxBloc';
import PresentationBloc from './PresentationBloc';

interface Props {
  maintenance?: boolean;
}

function HomePage(props: Props) {
  const [cookies, setCookies] = useCookies();
  return (
    <Layout>
      <PresentationBloc langue={cookies['langue'] || 'fr'} />
      <ActualitesBloc langue={cookies['langue'] || 'fr'} />
      <BureauxBloc langue={cookies['langue'] || 'fr'} />
    </Layout>
  );
}

export default HomePage
